import React, { createContext, useState, useEffect,useContext, useCallback } from "react";
import axios from "axios";
import { baseURL } from "../constants/url";

export const WishlistContext = createContext();

export const WishlistProvider = ({ children }) => {
  const [wishlistCount, setWishlistCount] = useState(0);

  const fetchWishlistCount = useCallback(async () => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      setWishlistCount(0);
      return;
    }

    try {
      const response = await axios.get(`${baseURL}common/wishlist`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = response.data;
      console.log("Wishlist API response:", data); // Optional: remove after debugging

      if (Array.isArray(data)) {
        setWishlistCount(data.length);
      } else if (data && typeof data.wishlist_count === "number") {
        setWishlistCount(data.wishlist_count);
      } else if (data?.wishlist && Array.isArray(data.wishlist)) {
        setWishlistCount(data.wishlist.length);
      } else {
        console.warn("Unexpected wishlist response format:", data);
        setWishlistCount(0);
      }
    } catch (error) {
      console.error("Error fetching wishlist:", error);
      setWishlistCount(0);
    }
  }, []);

  useEffect(() => {
    fetchWishlistCount();

    const handleStorageChange = () => {
      fetchWishlistCount();
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [fetchWishlistCount]);

  return (
    <WishlistContext.Provider value={{ wishlistCount, fetchWishlistCount }}>
      {children}
    </WishlistContext.Provider>
  );
};

export const useWishlist = () => useContext(WishlistContext);